export default "__VITE_ASSET__JAyOdEdQ__"